import React from 'react';

import { cn } from '@ui/lib/utils';

import { DecorativeCircles } from '../decorativeCircles/DecorativeCircles';

export interface LandingWrapperProps {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
  disableMinHeight?: boolean;
  /**
   * When true, the internal `layout-bounds` class (which applies large horizontal
   * margins on tablet/desktop) is not applied. Use this when the wrapper is
   * rendered inside a narrow container where the page-level margins would
   * otherwise eat most of the available width.
   */
  disableLayoutBounds?: boolean;
}

export const LandingWrapper: React.FC<LandingWrapperProps> = ({
  children,
  className = '',
  containerClassName = '',
  disableMinHeight = false,
  disableLayoutBounds = false
}) => {
  return (
    <section
      className={cn(
        'w-full bg-gradient-to-b from-primary-0/50 to-primary-0/0 overflow-x-clip relative py-8 md:py-16',
        className
      )}
    >
      {/* Background blur effects */}
      <div
        className="absolute right-[5%] top-[5%] h-96 w-80 -z-10 pointer-events-none animate-pulse bg-accent-purple-200/50 opacity-80 blur-[100px]"
        aria-hidden="true"
      />
      <div
        className="absolute bottom-[5%] left-[5%] h-96 w-96 -z-10 pointer-events-none animate-pulse bg-accent-rose-200/50 opacity-50 blur-[100px]"
        aria-hidden="true"
      />

      <div
        className={cn(
          'relative flex items-center',
          !disableLayoutBounds && 'layout-bounds',
          !disableMinHeight && 'min-h-[451px]',
          containerClassName
        )}
      >
        {/* Decorative circles */}
        <DecorativeCircles className="absolute w-[776px] right-[-153px] top-[-124px] md:right-[-153px] md:top-[-124px] -z-10" />
        <DecorativeCircles className="absolute w-[578px] left-[-172px] bottom-[-310px] md:left-[-320px] md:bottom-[-310px] -z-10" />

        {/* Content */}
        <div className="flex h-full w-full flex-col items-center justify-between md:flex-row gap-8">{children}</div>
      </div>
    </section>
  );
};
